// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_cart
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackViewMiniCartItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackViewMiniCartParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackViewMiniCartItem> {}

const trackViewMiniCart = (parameters: TrackViewMiniCartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "view_minicart", ...parameters }, options);
};

export default trackViewMiniCart;
